import { inferRouteObject } from 'react-router-typed-object';

import { CampaignPositionStatus } from '@/services/ws-print-operations/src/main/resources/rest-api';
import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import PrintOperations from 'src/scenes/PrintOperationsNew';
import Status from 'src/scenes/Status';

const index = true;

export const printOperationsRouteObjectNew = inferRouteObject({
  path: 'print-operations-new',
  element: <PrivateRoute roles={Roles.MANAGE_PRINT_PRODUCTS} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: PrintOperations.Helmet,
      children: [
        {
          path: 'print',
          Component: PrintOperations.PrintLayout,
          children: [
            {
              path: ':activeTabId',
              Component: PrintOperations.PrintPage,
            },
            {
              index,
              element: <Navigate to={`./${CampaignPositionStatus.READY_TO_PUSH}`} replace />,
            },
          ],
        },
        {
          path: 'publication-upload',
          Component: PrintOperations.PublicationUpload,
        },
        {
          index,
          element: <Navigate to='./print' replace />,
        },
      ],
    },
  ],
});
